import React, { useRef, useEffect, memo } from 'react';
import { View, StyleSheet, Text, useWindowDimensions } from 'react-native';
import { COLORS, FONTS, FONT_SIZES } from '@bcm/constants';

import Icon from '../icon/Icon';
import GlobalPressable from './GlobalPressable';

import { ICON_SIZE } from '../../../constants/UIConstants';
import { defaultBorder } from '../styles/common';

const LoadingButton = ({
	color,
	textColor,
	name,
	onPress,
	icon,
	iconSize,
	iconColor,
	title,
	isLockingForced
}) => {
	const isMounted = useRef(false);
	const layout = useWindowDimensions();
	const styles = StyleSheet.create({
		buttonWrapper: {
			marginHorizontal: 2,
			marginVertical: 2,
			backgroundColor: color ? color: COLORS.primary,
			height: 40,
			minWidth: (layout.width / 4) < 90 ? (layout.width / 4.2) : 90,
			borderRadius: defaultBorder,
			overflow: 'hidden',
			flexDirection: 'column',
			justifyContent: 'center',
		},
		button: {
			height: 40,
			backgroundColor: color ? color: COLORS.primary,
			flexDirection: 'row',
			justifyContent: 'center',
			alignItems: 'center',
		},
		buttonText: {
			fontFamily: FONTS.default,
			fontSize: FONT_SIZES.xl,
			color: textColor ? textColor: COLORS.white,
			margin: 5,
		},
	});

	useEffect(() => {
		isMounted.current = true;
		return () => isMounted.current = false;
	}, []);

	return (
		<View
			style={styles.buttonWrapper}
			testID={`${name}LoadingButtonContainer`}
		>
			<GlobalPressable
				style={styles.button}
				onPress={onPress}
				testID={`${name}LoadingButtonPressable`}
				isLockingForced={isLockingForced}
			>
				{icon && <Icon
					icon={icon}
					size={(iconSize) ? iconSize : ICON_SIZE.sm}
					color={(iconColor) ? iconColor : COLORS.white}
					testID={`${name}LoadingButtonIcon`}
				/>}
				{title && <Text
					numberOfLines={1}
					style={styles.buttonText}
				>
					{title}
				</Text>}
			</GlobalPressable>
		</View>
	);
};

export default memo(LoadingButton);
